import React, { createContext, useContext, useState, useCallback } from "react";

const ConfettiContext = createContext();

export const useConfetti = () => {
	const context = useContext(ConfettiContext);
	if (!context) {
		throw new Error("useConfetti must be used within a ConfettiProvider");
	}
	return context;
};

export const ConfettiProvider = ({ children }) => {
	const [confettiActive, setConfettiActive] = useState(false);
	const [confettiKey, setConfettiKey] = useState(0);

	const triggerConfetti = useCallback((duration = 3000) => {
		setConfettiActive(true);
		setConfettiKey((prev) => prev + 1);

		// Auto-stop confetti after specified duration
		setTimeout(() => {
			setConfettiActive(false);
		}, duration);
	}, []);

	const stopConfetti = useCallback(() => {
		setConfettiActive(false);
	}, []);

	const value = {
		confettiActive,
		confettiKey,
		triggerConfetti,
		stopConfetti,
	};

	return (
		<ConfettiContext.Provider value={value}>
			{children}
		</ConfettiContext.Provider>
	);
};
